<template>
  <div class="flex gap-8">
    <!-- Hide content for screen reader due to issues and read an aria label -->
    <!-- eslint-disable-next-line vuejs-accessibility/heading-has-content -->
    <h1 class="flex gap-8 wrap" :aria-label="headingTextForScreenReader">
      <BoxedText
        box-color-class="bg-surface-primary"
        element="span"
        text-class="heading-sm"
        line-height="leading-[160%]"
        aria-hidden="true"
      >
        {{ store.product?.ManufacturerName }}
      </BoxedText>
      <BoxedText
        box-color-class="bg-surface-primary"
        element="span"
        text-class="heading-sm"
        line-height="leading-[160%]"
        aria-hidden="true"
      >
        {{ store.product?.ProductName }}
      </BoxedText>
    </h1>
    <AppLabel
      v-if="shouldShowPreOwnedLabel"
      color="beg"
      text="Begagnad"
      :aria-label="labelTextForScreenReader"
    />
  </div>
</template>

<script lang="ts" setup>
import { NEW_CONDITION } from '~/models/ListingProduct.api.model';

const store = useMyProductPageStore();

const shouldShowPreOwnedLabel = computed(
  () =>
    store.currentVariant?.Condition &&
    store.currentVariant.Condition !== NEW_CONDITION,
);

const headingTextForScreenReader = computed(() =>
  [store.product?.ManufacturerName, store.product?.ProductName]
    .filter(Boolean)
    .join(' '),
);

const labelTextForScreenReader = computed(
  () => `Begagnat i ${store.currentVariant?.Condition}`,
);
</script>

<style></style>
